module.exports = __webpack_public_path__ + "static/media/screen5.834f42b6.png";